import { useOauthLoginMutation } from "api/auth/auth.mutation";
import PageLoader from "components/PageLoader";
import { handleError } from "functions/apiHandleError";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useStore from "store";

const OauthLogin = () => {
  const history = useNavigate();
  const { storeLogin, accessTokenStore, storeSetLoading, isLoadingStore } = useStore();
  const oauthLoginMutation = useOauthLoginMutation();
  const hash = window.location.hash.substring(1);
  const params = hash.split("&");
  const parsedParams = {};
  params.forEach((param) => {
    const [key, value] = param.split("=");
    parsedParams[key] = value;
  });
  const accessToken = parsedParams["access_token"];

  const getLoginUser = async () => {
    storeSetLoading(true);
    try {
      const response = await oauthLoginMutation.mutateAsync(accessToken);
      const { auth_token, ...userInfo } = response;
      storeLogin(auth_token, userInfo);
      history("/dashboard");
    } catch (err) {
      handleError({ err });
    } finally {
      storeSetLoading(false);
    }
  };

  useEffect(() => {
    if (accessTokenStore) {
      history("/dashboard");
    }
    getLoginUser();
  }, []);

  if (isLoadingStore) {
    return <PageLoader isLoading={true} />;
  }
};

export default OauthLogin;
